/* eslint-disable  */
import React, { useEffect, useState } from 'react';
import { Container, Table, Header } from 'semantic-ui-react';
import { api } from '#/apis';
import Dimmer from '+/Dimmer';
import dayjs from 'dayjs';
import {min} from 'lodash'




const ViewAllPricing = props => {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(false);


    useEffect(() => {
        setLoading(true);
        api.get('/allPricing')
            .then(({ data }) => {
                // console.log(data.rows);
                setData(data);
                setLoading(false);
            })
            .catch(err => {
                setErr(true);
            });
    }, []);

    if (err){
        return <Dimmer message='SOMETHING WENT WRONG, PLEASE RELOAD PAGE' />;
    }

    if (loading || !data) return <Dimmer message='Loading....This may take a while.'/>;


    return (
        <Container fluid className='overflow-x'>
            <Header content='All Units Pricing Report'/>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Property' />
                        <Table.HeaderCell content='Satus' />
                        <Table.HeaderCell content='UnitType' />
                        <Table.HeaderCell content='Unit' />
                        <Table.HeaderCell content='Unit Type Rent' />
                        <Table.HeaderCell content='Amenity Rent' />
                        <Table.HeaderCell content='Market Rent' />
                        <Table.HeaderCell content='Current Rent' />
                        
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {(data || []).map((row, i) => (
                        <Table.Row key={i}>
                            <Table.Cell content={row.property_name} />
                            <Table.Cell content={row.status} />
                            <Table.Cell content={row.unit_type} />
                            <Table.Cell content={row.unit_name} />
                            <Table.Cell content={row.marketRent} />
                            <Table.Cell content={row.amenityRent} />
                            <Table.Cell content={row.marketRent + row.amenityRent } />
                            <Table.Cell content={row.currentRent} />


                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

        </Container>
    );
};


export default ViewAllPricing;